export default __webpack_public_path__ + "static/media/hotel.1e2351bf.jpg";